import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";
import { AngularSvgIconModule } from "angular-svg-icon";
import { DropzoneModule } from "ngx-dropzone-wrapper";
import { ModalsModule } from "../shared/modals/modals.module";
import { SharedModule } from "../shared/shared.module";
import { ProductRangeModule } from "./../product-range/product-range.module";
import { AddressComponent } from "./address/address.component";
import { BaseCostsComponent } from "./base-costs/base-costs.component";
import { OptionsPricingComponent } from "./options-pricing/options-pricing.component";
import { ProductTypeConfigComponent } from "./product-type-config/product-type-config.component";
import { ProductTypesComponent } from "./product-types/product-types.component";
import { RangeComponent } from "./range/range.component";
import { SupplierStepthroughComponent } from "./supplier-stepthrough/supplier-stepthrough.component";
import { SupplierComponent } from "./supplier/supplier.component";
import { UserComponent } from "./user/user.component";

@NgModule({
    declarations: [
        SupplierComponent,
        UserComponent,
        RangeComponent,
        ProductTypesComponent,
        SupplierStepthroughComponent,
        AddressComponent,
        BaseCostsComponent,
        OptionsPricingComponent,
        ProductTypeConfigComponent,
    ],
    exports: [
        SupplierStepthroughComponent,
        ProductTypeConfigComponent,
        OptionsPricingComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        DropzoneModule,
        ProductRangeModule,
        NgSelectModule,
        AngularSvgIconModule,
        ModalsModule,
    ],
})
export class SupplierStepthroughModule {}
